export default "__VITE_ASSET__BmLYqA5C__"